import axios from './_contaAxios'

// Consultar logics

export const obtenerAsNivel3Select = () => axios.get('/presupuestos', { params: { tipoConsulta: 'nivel3-select' } })

export const obtenerAsNivel3Select2 = ({ busqueda }) =>
  axios.get('/presupuestos', { params: { tipoConsulta: 'nivel3-select2', busqueda } })
